import React from 'react';
import { Breadcrumb } from 'semantic-ui-react';
import { Link, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { defineMessages, useIntl } from 'react-intl';
import { getNearestInstitut } from 'volto-fzj-internet/actions';
import { flattenToAppURL, getBaseUrl } from '@plone/volto/helpers';
import config from '@plone/volto/registry';

const messages = defineMessages({
  home: {
    id: 'Home',
    defaultMessage: 'Home',
  },
  root: {
    id: 'Root',
    defaultMessage: 'Root',
  },
});

const ContentsBreadcrumbs = (props) => {
  const { settings } = config;
  const { items } = props;
  const intl = useIntl();
  const pathname = useLocation().pathname;
  const lang = pathname.split('/')[1];

  const dispatch = useDispatch();
  const nearestInstitut = useSelector((state) => state.nearestinstitut);
  const institut = nearestInstitut.institut;
  const institutsBereich = nearestInstitut.institutsbereich;
  const blogs = nearestInstitut.blogs;

  React.useEffect(() => {
    dispatch(getNearestInstitut(getBaseUrl(pathname)));
  }, [dispatch, pathname]);

  return (
    <Breadcrumb>
      {settings.isMultilingual && (
        <>
          <Link
            to="/contents"
            className="section"
            title={intl.formatMessage(messages.root)}
          >
            {intl.formatMessage(messages.root)}
          </Link>
          <Breadcrumb.Divider />
        </>
      )}
      {settings.isMultilingual && pathname?.split('/')?.length > 2 && (
        <Link
          to={`/${lang}/contents`}
          className="section"
          title={intl.formatMessage(messages.home)}
        >
          {lang}
        </Link>
      )}
      {settings.isMultilingual &&
        pathname?.split('/')?.length > 2 &&
        institut?.['@id'] && (
          <>
            <Breadcrumb.Divider />
            <Link
              to={flattenToAppURL(`${institut['@id']}/contents`)}
              className="section"
              title={intl.formatMessage(messages.home)}
            >
              {institut.name}
            </Link>
          </>
        )}
      {settings.isMultilingual &&
        pathname?.split('/')?.length > 2 &&
        institutsBereich?.['@id'] && (
          <>
            <Breadcrumb.Divider />
            <Link
              to={flattenToAppURL(`${institutsBereich['@id']}/contents`)}
              className="section"
              title={intl.formatMessage(messages.home)}
            >
              {institutsBereich.name}
            </Link>
          </>
        )}
      {settings.isMultilingual &&
        pathname?.split('/')?.length > 2 &&
        blogs?.['@id'] && (
          <>
            <Breadcrumb.Divider />
            <Link
              to={flattenToAppURL(`${blogs['@id']}/contents`)}
              className="section"
              title={intl.formatMessage(messages.home)}
            >
              {blogs.name}
            </Link>
          </>
        )}
      {!settings.isMultilingual && (
        <Link
          to="/contents"
          className="section"
          title={intl.formatMessage(messages.home)}
        >
          {intl.formatMessage(messages.home)}
        </Link>
      )}
      {items.map((breadcrumb, index, breadcrumbs) => [
        <Breadcrumb.Divider key={`divider-${breadcrumb.url}`} />,
        index < breadcrumbs.length - 1 ? (
          <Link
            key={breadcrumb.url}
            to={`${breadcrumb.url}/contents`}
            className="section"
          >
            {breadcrumb.nav_title || breadcrumb.title}
          </Link>
        ) : (
          <Breadcrumb.Section key={breadcrumb.url} active>
            {breadcrumb.nav_title || breadcrumb.title}
          </Breadcrumb.Section>
        ),
      ])}
    </Breadcrumb>
  );
};

export default ContentsBreadcrumbs;
